export default __webpack_public_path__ + "static/media/GhirardelliSquare.1524f443.jpg";